import React, { useEffect, useRef, useState } from 'react';
interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: string;
  record: any;
  bookInfo?: any;
  handleSave: (record: any) => void;
}
const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  bookInfo,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (editing) {
      inputRef.current!.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    if (bookInfo?.registDiv === 'MU' || bookInfo?.bookNo) return;
    setEditing(!editing);
  };
  const save = async () => {
    try {
      if (!inputRef.current.value) {
        inputRef.current.value = 0;
      }
      toggleEdit();
      handleSave({ ...record, [dataIndex]: Number(inputRef.current.value) });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <div className={'flex flex-justify-start flex-align-center'}>
        <input
          type="text"
          ref={inputRef}
          className="form-control"
          name={dataIndex}
          onChange={(e) =>
            (e.target.value = e.target.value
              .replace(/[^0-9.]/g, '')
              .replace(/(\..*)\./g, '$1'))
          }
          onBlur={save}
          maxLength={2}
          onKeyPress={(e) => {
            if (e.key === 'Enter') save();
          }}
        />
      </div>
    ) : (
      <div className={`editable-cell-value-wrap`} onDoubleClick={toggleEdit}>
        {children}
      </div>
    );
  }

  return (
    <td
      {...restProps}
      className={`w-80p ${
        bookInfo?.bookNo &&
        bookInfo?.registDiv === 'MU' &&
        !record?.bookNo &&
        !inputRef?.current?.value
          ? 'b-color-showUp'
          : ''
      }`}
    >
      {childNode}
    </td>
  );
};

export default EditableCell;
